import { createContext, useContext } from 'react';
export const BackgroudAppContext = createContext(null);
export function useBackgroundAppContext() {
    return useContext(BackgroudAppContext);
}
export function usePostBackgroundMessage() {
    const app = useBackgroundAppContext();
    return (message) => {
        app.postMessage(message);
    };
}
export function usePostAsyncBackgroundMessage() {
    const app = useBackgroundAppContext();
    return (message) => app.postAsyncMessage(message);
}
